import { analyticsUrl } from 'utils/wrappers';

import PageableBase, { PAGING_TYPES } from 'app/collections/pageable_base';
import ModelBase from 'app/models/base';

export const DestinationReliability = ModelBase.extend({});

export default PageableBase.extend({
  model: DestinationReliability,
  key: 'destinations_reliabilities',
  url: analyticsUrl('tracking/v2/carriers/destinations_reliability'),
  pagingType: PAGING_TYPES.PER_PAGE,

  initialize(models, {
    dateRange, carrierSelection, servicePrioritySelection, destinationLevelSelection, exceptionTypeSelection
  }) {
    this.dateRange = dateRange;
    this.carrierSelection = carrierSelection;
    this.servicePrioritySelection = servicePrioritySelection;
    this.destinationLevelSelection = destinationLevelSelection;
    this.exceptionTypeSelection = exceptionTypeSelection;

    this.listenTo(this.dateRange, 'change', this.resetToFirstPage);
    this.listenTo(this.carrierSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.servicePrioritySelection, 'change', this.resetToFirstPage);
    this.listenTo(this.destinationLevelSelection, 'change', this.resetToFirstPage);
    this.listenTo(this.exceptionTypeSelection, 'change', this.resetToFirstPage);
  },

  paramsForFetch() {
    return {
      ...this.dateRange.getParams(),
      ...this.carrierSelection.getParams(),
      ...this.servicePrioritySelection.getParams(),
      ...this.destinationLevelSelection.getParams(),
      ...this.exceptionTypeSelection.getParams(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/collections/destination_reliabilities.js